import type { UA_AddUnitsData, UA_IFilterUnit } from './UA.types'

// Note: This mutates the addUnitsData object
//
export function UA_selectAllByType(addUnitsData: UA_AddUnitsData, unitId: number) {
    // Update all children - by mutating them in place
    //
    const setSelect = (filterUnit: UA_IFilterUnit, selected: boolean) => {
        filterUnit.selected = selected

        // Don't recurse further down if we've reached the target level
        if (filterUnit.unitTypeId === addUnitsData.targetUnitTypeId) {
            return
        }

        const unit = addUnitsData.unitsLookup.get(filterUnit.unitId)
        const childrenIds = unit.children
        const childFilterUnits = childrenIds
            .map((id) => addUnitsData.filterUnitsLookup.get(id))
            .filter((filterUnit) => filterUnit !== undefined)

        childFilterUnits.forEach((childFilterUnit) => {
            setSelect(childFilterUnit, selected)
        })
    }

    const filterUnit = addUnitsData.filterUnitsLookup.get(unitId)
    const selected = !filterUnit.selected

    // Recursively set select to unit & all children
    setSelect(filterUnit, selected)

    // Update all children - by mutating them in place
    //
    const updateParents = (filterUnit: UA_IFilterUnit) => {
        // Find all filterUnits for the parent of this unit
        const unit = addUnitsData.unitsLookup.get(filterUnit.unitId)
        const parentIds = unit.parents
        const parentFilterUnits = parentIds
            .map((id) => addUnitsData.filterUnitsLookup.get(id))
            .filter((filterUnit) => filterUnit !== undefined)

        // For each parent, find all the children of that parent and set the parent to be selected if
        // all the children are selected, and unselected otherwise
        parentFilterUnits.forEach((parentFilterUnit) => {
            const parentUnit = addUnitsData.unitsLookup.get(parentFilterUnit.unitId)
            const childrenIds = parentUnit.children
            const childFilterUnits = childrenIds
                .map((id) => addUnitsData.filterUnitsLookup.get(id))
                .filter((filterUnit) => filterUnit !== undefined)

            parentFilterUnit.selected = childFilterUnits.every((childFilterUnit) => childFilterUnit.selected)
        })

        // Recurse over the parents' parents. We do this in a separate loop so that all parents at
        // this level are updated before we move up to the next level
        parentFilterUnits.forEach((parentFilterUnit) => {
            updateParents(parentFilterUnit)
        })
    }

    updateParents(filterUnit)
}
